import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../../styles/theme';

// Container principal del header
export const StepHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  margin: `0 ${theme.spacing(2)}`,
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  borderRadius: theme.spacing(1),
  transition: 'all 0.3s ease-in-out',
  position: 'relative',
  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
    borderRadius: theme.spacing(1),
    zIndex: 0,
  },
}));

// Barra lateral de color
export const StepHeaderBorder = styled(Box)(({ theme }) => ({
  width: '8px',
  alignSelf: 'stretch',
  marginRight: theme.spacing(2),
  borderRadius: theme.spacing(0.5),
  transition: 'all 0.3s ease-in-out',
  position: 'relative',
  zIndex: 1,
}));

// Container del icono
export const StepHeaderIcon = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease-in-out',
  position: 'relative',
  zIndex: 1,

  '& svg': {
    transition: 'transform 0.3s ease-in-out',
  },

  '&:hover svg': {
    transform: 'scale(1.1)',
  },
}));

// Título del paso
export const StepHeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 600,
  color: colors.text.primary,
  position: 'relative',
  zIndex: 1,
  transition: 'all 0.3s ease-in-out',
}));

// Descripción del paso
export const StepHeaderDescription = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: colors.text.secondary,
  marginTop: theme.spacing(0.5),
  position: 'relative',
  zIndex: 1,
}));

// Variantes de color
export const StepHeaderContainerPurple = styled(StepHeaderContainer)(({ theme }) => ({
  backgroundColor: 'rgba(147, 51, 234, 0.1)',
  border: `1px solid rgba(147, 51, 234, 0.2)`,
}));

export const StepHeaderContainerBlue = styled(StepHeaderContainer)(({ theme }) => ({
  backgroundColor: 'rgba(59, 130, 246, 0.1)',
  border: `1px solid rgba(59, 130, 246, 0.2)`,
}));

export const StepHeaderContainerGreen = styled(StepHeaderContainer)(({ theme }) => ({
  backgroundColor: 'rgba(16, 185, 129, 0.1)',
  border: `1px solid rgba(16, 185, 129, 0.2)`,
}));

// Variantes de tamaño
export const StepHeaderContainerSmall = styled(StepHeaderContainer)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  marginBottom: theme.spacing(2),

  '& .MuiTypography-root': {
    fontSize: '16px',
  },
}));

export const StepHeaderContainerLarge = styled(StepHeaderContainer)(({ theme }) => ({
  padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
  marginBottom: theme.spacing(4),

  '& .MuiTypography-root': {
    fontSize: '20px',
  },
}));

// Animaciones
export const StepHeaderContainerAnimated = styled(StepHeaderContainer)(({ theme }) => ({
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
}));

// Efecto de brillo
export const StepHeaderContainerShimmer = styled(StepHeaderContainer)(({ theme }) => ({
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    animation: 'shimmer 2s infinite',
    zIndex: 0,
  },

  '@keyframes shimmer': {
    '0%': {
      left: '-100%',
    },
    '100%': {
      left: '100%',
    },
  },
}));
